<template>
    <div class="accountsReceiveData">
        <div class="mainContentWrap">
            <el-row>
                <el-col :span="24">
                    <div class="title">{{projectName}}</div>
                    <div class="unitClass">单位：元</div>

                    <div class="top1">
                        <div>
                            <span>欠款单位</span>
                            <br/>
                            {{sumData.debtCompany}}
                        </div>
                        <div>
                            <span>审计及竣工情况</span>
                            <br/>
                            {{sumData.auditSituation}}
                        </div>
                        <div>
                            <span>应返还时间</span>
                            <br/>
                            {{sumData.backDate}}
                        </div>
                        <div>
                            <span>预计回收时间</span>
                            <br/>
                            {{sumData.backExpectDate}}
                        </div>
                    </div>
                    <div class="top">
                        <el-row>
                            <el-col :span="10">
                                <div class="top_sum">
                                    审计额或已完成产值
                                    <br/>
                                    {{formatCurrency(sumData.auditAmount)}}
                                </div>
                                <div class="top_sum top_sum1">
                                    应收账款
                                    <br/>
                                    {{formatCurrency(sumData.debtTotalMoney)}}
                                </div>
                            </el-col>
                            <el-col :span="14">
                                <div class="echart1" id="echart23Top"></div>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="middle">
                        <el-row>
                            <el-col :span="14">
                                <div class="title">欠款金额明细分析</div>
                                <div class="echart1" id="echart23MiddleLeft"></div>
                            </el-col>
                            <el-col :span="10">
                                <div class="title">按帐龄划分金额</div>
                                <div class="echart1" id="echart23MiddleRight"></div>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="bottom">
                        <div class="title">回收趋势</div>
                        <div class="echart1" id="echart23bottom"></div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
    import {getReceiveAnalysisAuditAmountProject} from "../../services/dataCenterAService";

    var echarts = require('echarts/lib/echarts');
    // 引入柱状图
    require('echarts/lib/chart/bar');
    require('echarts/lib/chart/pie');
    require('echarts/lib/chart/line');
    // 引入提示框和标题组件
    require('echarts/lib/component/tooltip');
    require('echarts/lib/component/title');
    export default {
        name: "accountsReceiveData",

        data() {
            return {
                //顶部数据
                projectName: "",
                sumData: {},
                //中间部分数据
                echart23MiddleRight: null,
                echart23MiddleLeft: null,
                echart23: null,
                echart23bottom: null,
            };
        },
        methods: {
            setWrapHeight() {
                let cww = document.getElementsByClassName("accountsReceiveTotalWrap")[0]
                    .offsetWidth;
                let ch = Math.ceil((1660 / 900) * cww * 0.98);
                if (document.getElementById("aside")) {
                    ch = 1660;
                    document.getElementsByClassName("accountsReceiveData")[0].style.width =
                        "900px";
                }
                document.getElementsByClassName("accountsReceiveData")[0].style.height =
                    ch + "px";

                if (this.echart23MiddleRight) {
                    this.echart23MiddleRight.resize();
                }

                if (this.echart23MiddleLeft) {
                    this.echart23MiddleLeft.resize();
                }

                if (this.echart23) {
                    this.echart23.resize();
                }

                if (this.echart23bottom) {
                    this.echart23bottom.resize();
                }

            },
            search(searchData) {
                let _this = this;
                //查询项目部下的数据

                //查询看板数据
                let params = {};
                if (searchData.monthDate) {
                    params.monthDate = searchData.monthDate;
                }
                 if (searchData.projectProcess) {
                    params.projectProcess = searchData.projectProcess;
                }
                if (searchData.deptId) {
                    params.deptId = searchData.deptId;
                }
                if (searchData.projectId) {
                    params.projectId = searchData.projectId;
                }
                getReceiveAnalysisAuditAmountProject(params)
                    .then(res => {
                        if (res.code === 10000000) {
                            _this.projectName = searchData.projectName;
                            //顶部部分数据
                            _this.sumData = res.data;
                            this.$nextTick(() => {
                                let centerParams = {
                                    collectedMoney: this.sumData.collectedMoney,
                                    debtTotalMoney: this.sumData.debtTotalMoney
                                };
                                this.draw(centerParams, "Top"); //顶部饼状图
                                let bottomLeftParams = [
                                    {value: this.sumData.retentionMoney, name: "质保金"},
                                    {
                                        value: this.sumData.projectMoney,
                                        name: "需交工验收、审计、竣工验收后应支付工程款(不含质保金)"
                                    },
                                    {
                                        value: this.sumData.processMoney,
                                        name:
                                            "按进度应支付工程款(欠款总额-质保金-需交工验收、审计、竣工验收后应支付工程款)"
                                    }
                                ];
                                this.drawBottomLeft(bottomLeftParams); //底部左边饼状图
                                this.drawBottomRight(); //底部右边饼状图
                                let bottomName = [];
                                let bottomData = [];
                                res.data.receiveTrendDtoList.forEach(item => {
                                    bottomName.push(item.enterDate);
                                    bottomData.push(item.pct);
                                });
                                this.drawBottom(bottomData, bottomName); //底部折线图
                            });
                        } else if (res.code > 20000000) {
                            this.$alert(res.msg, "提示", {
                                confirmButtonText: "确定"
                            });
                        } else {
                            this.$message.error("系统异常");
                        }
                    })
                    .catch(error => {
                        this.$message.error("系统异常");
                    });
            },
            //    绘制顶部饼状图
            draw(item, index) {
                let _this = this
                console.log(index);
                let idName = "echart23" + index;
                // let myChart = echarts.init(document.getElementById(idName));
                this.echart23 = echarts.init(document.getElementById(idName));
                let option = {
                    title: {
                        show: false
                    },
                    tooltip: {
                        trigger: "item",
                        showDelay: 20, // 显示延迟，添加显示延迟可以避免频繁切换，单位ms
                        hideDelay: 20, // 隐藏延迟，单位ms
                        textStyle: {
                            fontSize: "16px",
                            color: "#fff" // 设置文本颜色 默认#FFF
                        },
                        formatter: "{b} : {d}%"
                    },
                    legend: {
                        orient: "horizontal",
                        icon: "circle",
                        bottom: 10,
                        itemHeight: 5,
                        itemWidth: 5,
                        left: "center",
                        data: ["已收款", "应收账款"]
                    },
                    color: ["#f79646", "#4bacc6"],
                    series: [
                        {
                            name: "",
                            type: "pie",
                            radius: "67%",
                            center: ["50%", "48%"],
                            data: [
                                {value: item.collectedMoney, name: "已收款"},
                                {value: item.debtTotalMoney, name: "应收账款"}
                            ],
                            // 设置值域的那指向线
                            labelLine: {
                                normal: {
                                    show: false // show设置线是否显示，默认为true，可选值：true ¦ false
                                }
                            },
                            // 设置值域的标签
                            label: {
                                normal: {
                                    padding: [0, -20],
                                    textStyle: {
                                        fontSize: 12,
                                        color: "rgba(0,0,0,0.8)"
                                    },
                                    // formatter: "{b}\n{d}%"
                                    formatter: function (params) {
                                        let txt = ''
                                        txt = params.name + '\n' + params.percent + '%' + '\n' + _this.formatCurrency(params.value)
                                        return txt
                                    }
                                }
                            }
                        }
                    ]
                };
                this.echart23.setOption(option);
            },
            //绘制底部左边圆形图
            drawBottomLeft(bottomLeftParams) {
                let _this = this
                // let bottomLeftChart = echarts.init(
                //   document.getElementById("echart23MiddleLeft")
                // );

                this.echart23MiddleLeft = echarts.init(
                    document.getElementById("echart23MiddleLeft")
                );


                let option = {
                    title: {
                        show: false
                    },
                    tooltip: {
                        trigger: "item",
                        showDelay: 20, // 显示延迟，添加显示延迟可以避免频繁切换，单位ms
                        hideDelay: 20, // 隐藏延迟，单位ms
                        textStyle: {
                            fontSize: "16px",
                            color: "#fff" // 设置文本颜色 默认#FFF
                        },
                        formatter: "{c}"
                    },
                    legend: {
                        // orient: 'horizontal',
                        orient: "vertical",
                        icon: "circle",
                        bottom: 10,
                        itemHeight: 5,
                        itemWidth: 5,
                        left: "center",
                        data: [
                            "质保金",
                            "需交工验收、审计、竣工验收后应支付工程款(不含质保金)",
                            "按进度应支付工程款(欠款总额-质保金-需交工验收、审计、竣工验收后应支付工程款)"
                        ]
                    },
                    color: ["#f79646", "#4bacc6", "#8064a2"],
                    // b65708
                    series: [
                        {
                            name: "",
                            type: "pie",
                            radius: "50%",
                            center: ["50%", "40%"],
                            data: bottomLeftParams,
                            // 设置值域的那指向线
                            labelLine: {
                                normal: {
                                    show: false // show设置线是否显示，默认为true，可选值：true ¦ false
                                }
                            },
                            // 设置值域的标签
                            label: {
                                normal: {
                                    padding: [0, -20],
                                    textStyle: {
                                        fontSize: 12,
                                        color: "rgba(0,0,0,0.8)"
                                    },
                                    // formatter: "{c}"
                                    formatter: function (params) {
                                        return _this.formatCurrency(params.value)
                                    }
                                }
                            }
                        }
                    ]
                };
                this.echart23MiddleLeft.setOption(option);

            },
            //绘制底部右边圆形图
            drawBottomRight() {
                let _this = this
                // let bottomRightChart = echarts.init(
                //   document.getElementById("echart23MiddleRight")
                // );
                this.echart23MiddleRight = echarts.init(
                    document.getElementById("echart23MiddleRight")
                );

                let option = {
                    title: {
                        show: false
                    },
                    tooltip: {
                        trigger: "item",
                        showDelay: 20, // 显示延迟，添加显示延迟可以避免频繁切换，单位ms
                        hideDelay: 20, // 隐藏延迟，单位ms
                        textStyle: {
                            fontSize: "16px",
                            color: "#fff" // 设置文本颜色 默认#FFF
                        },
                        formatter: "{c}"
                    },
                    legend: {
                        orient: "horizontal",
                        icon: "circle",
                        bottom: 30,
                        itemHeight: 5,
                        itemWidth: 5,
                        left: "center",
                        data: ["1年以内", "1-2年", "2-3年", "3年(含)以上"]
                    },
                    color: ["#f79646", "#4bacc6", "#8064a2", "#b65708"],
                    series: [
                        {
                            name: "",
                            type: "pie",
                            radius: "50%",
                            center: ["50%", "40%"],
                            data: [
                                {value: this.sumData.withinOneYear, name: "1年以内"},
                                {value: this.sumData.oneToTwo, name: "1-2年"},
                                {value: this.sumData.twoToThree, name: "2-3年"},
                                {value: this.sumData.beyondThree, name: "3年(含)以上"}
                            ],

                            // 设置值域的那指向线
                            labelLine: {
                                normal: {
                                    show: false // show设置线是否显示，默认为true，可选值：true ¦ false
                                }
                            },
                            // 设置值域的标签
                            label: {
                                normal: {
                                    padding: [0, -20],
                                    textStyle: {
                                        fontSize: 12,
                                        color: "rgba(0,0,0,0.8)"
                                    },
                                    // formatter: "{c}"
                                    formatter: function (params) {
                                        return _this.formatCurrency(params.value)
                                    }
                                }
                            }
                        }
                    ]
                };
                this.echart23MiddleRight.setOption(option);

            },
            //绘制底部折线图
            drawBottom(bottomData, bottomName) {

                this.echart23bottom = echarts.init(
                    document.getElementById("echart23bottom")
                );


                let option = {
                    legend: {
                        show: false
                    },
                    grid: {
                        left: "5%",
                        right: "4%",
                        bottom: "5%",
                        top: "8%",
                        containLabel: true
                    },
                    tooltip: {
                        trigger: "item",
                        showDelay: 20, // 显示延迟，添加显示延迟可以避免频繁切换，单位ms
                        hideDelay: 20, // 隐藏延迟，单位ms
                        textStyle: {
                            fontSize: "16px",
                            color: "#fff" // 设置文本颜色 默认#FFF
                        },
                        formatter: "{c}"
                    },
                    color: ["#f79646", "#4bacc6", "#8064a2"],
                    xAxis: {
                        // data: ["平度特色小镇", "沈海高速", "仰口隧道"],
                        data: bottomName,
                        axisLabel: {
                            interval: 0,
                            rotate: 20
                        },
                        axisLine: {
                            // 坐标轴 轴线
                            show: false // 是否显示
                        },
                        axisTick: {
                            // 坐标轴的刻度
                            show: false // 是否显示
                        }
                    },
                    yAxis: {
                        show: true, // 是否显示
                        type: "value", // 轴类型，默认为 ‘category’
                        axisLine: {
                            // 坐标轴 轴线
                            show: false // 是否显示
                        },
                        axisTick: {
                            // 坐标轴的刻度
                            show: false // 是否显示
                        },
                        min: 0
                    },
                    series: [
                        {
                            name: "日期",
                            type: "line",
                            barWidth: 12, // 柱形的宽度
                            data: bottomData,
                            itemStyle: {
                                normal: {label: {show: true, color: "rgba(0,0,0,0.6)"}}
                            }
                        }
                    ]
                };
                this.echart23bottom.setOption(option);

            },

            //数字用逗号隔开
            formatCurrency(num) {
                num = Number(num)
                num = num.toFixed(2)
                if (num === 0) {
                    return 0;
                } else if (num) {
                    num = num.toString().replace(/\$|\,/g, "");
                    if (num === "" || isNaN(num)) {
                        return 0;
                    }
                    var sign = "";
                    if (num.indexOf("-") !== -1) {
                        sign = "-";
                        num = num.substr(1);
                    }
                    var cents = num.indexOf(".") > 0 ? num.substr(num.indexOf(".")) : "";
                    cents = cents.length > 1 ? cents : "";
                    num = num.indexOf(".") > 0 ? num.substring(0, num.indexOf(".")) : num;
                    if (cents === "") {
                        if (num.length > 1 && num.substr(0, 1) === "0") {
                            return 0;
                        }
                    } else {
                        if (num.length > 1 && num.substr(0, 1) === "0") {
                            return 0;
                        }
                    }
                    for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
                        num =
                            num.substring(0, num.length - (4 * i + 3)) +
                            "," +
                            num.substring(num.length - (4 * i + 3));
                    }
                    return sign + num + cents;
                }
            }
        }
    };
</script>

<style scoped lang="scss">
    .accountsReceiveData {
        /*height: calc(100% - 65px);*/
        /*text-align: left;*/
        /*!*overflow: hidden;*!*/
        /*background: #ffffff;*/
        /*padding:  0 10px;*/

        width: 98%;
        text-align: left;
        overflow: hidden;
        background: #ffffff;
        padding: 0 10px;
        height: 1660px;
        margin: 0 auto;

        .mainContentWrap {
            height: 99%;
            /*overflow: auto;*/
            /*height: calc(100% - 100px);*/
            /*height: 100%;*/
            .el-row {
                /*height: calc(100% - 50px);*/
                height: 100%;

                .el-col {
                    height: 100%;

                    .title {
                        text-align: center;
                        font-size: 24px;
                        line-height: 50px;
                        font-weight: 600;
                    }

                    .unitClass {
                        text-align: right;
                        font-size: 20px;
                    }

                    .top1 {
                        width: calc(100% - 10px);
                        border: 1px solid #c8c8c8;
                        height: 15%;
                        /*height: 248px;*/
                        padding-top: 4px;
                        margin: 5px;
                        display: flex;
                        justify-content: space-around;
                        flex-wrap: wrap;
                        text-align: center;
                        color: rgba(0, 0, 0, 0.8);
                        font-size: 18px;
                    }

                    .top1 > div {
                        margin-top: 1%;
                        width: 40%;
                        height: 38%;
                        background: #92d050;
                        /*line-height: 40px;*/
                        font-size: 16px;
                        font-weight: 600;

                        span {
                            font-size: 14px;
                        }
                    }

                    .top1 > div::before {
                        display: inline-block;
                        content: "";
                        height: 50%;
                        vertical-align: middle;
                    }

                    .top {
                        width: calc(100% - 10px);
                        border: 1px solid #c8c8c8;
                        /*height: 280px;*/
                        height: 17%;
                        padding-top: 6px;
                        margin: 5px;

                        .el-row {
                            height: 100%;

                            .el-col {
                                height: 100%;

                                .top_sum {
                                    text-align: center;
                                    height: 40%;
                                    font-size: 16px;
                                    font-weight: 600;
                                    line-height: 10px;
                                    background: #bdd0e9;
                                    width: 80%;
                                    margin: 2% auto 3%;
                                }

                                .top_sum1 {
                                    background: #f4b183;
                                    margin: 0 auto;
                                }

                                .top_sum::before {
                                    display: inline-block;
                                    content: "";
                                    height: 60%;
                                    vertical-align: middle;
                                }

                                .echart1 {
                                    height: 100%;
                                }
                            }
                        }
                    }

                    .middle {
                        width: calc(100% - 10px);
                        border: 1px solid #c8c8c8;
                        /*height: 420px;*/
                        height: 25%;
                        margin: 5px;

                        .el-row {
                            height: 100%;

                            .el-col {
                                height: 100%;

                                .title {
                                    text-align: left;
                                    font-size: 16px;
                                    line-height: 16px;
                                    margin: 10px 0 10px 10px;
                                }

                                .echart1 {
                                    height: calc(100% - 36px);
                                }
                            }
                        }
                    }

                    .bottom {
                        width: calc(100% - 10px);
                        border: 1px solid #c8c8c8;
                        /*height: 510px;*/
                        height: 31%;
                        margin: 5px;

                        .title {
                            text-align: left;
                            font-size: 16px;
                            line-height: 16px;
                            margin: 10px 0 10px 10px;
                        }

                        .echart1 {
                            height: calc(100% - 36px);
                        }
                    }
                }
            }
        }
    }
</style>

